/**
 * Identity function for translations
 * @param {String} str the string
 * @returns {String} the string
 */
export default function t(str) {
  return str;
}
